import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { Logger } from '../utils/Logger';
import { ExposedPromise } from '../utils/exposed-promise';
import { MatrixClientStore } from './MatrixClientStore';
import { MatrixHttpClient } from './MatrixHttpClient';
import { MatrixRoom, MatrixRoomStatus } from './models/MatrixRoom';
import { MatrixRoomService } from './services/MatrixRoomService';
import { MatrixUserService } from './services/MatrixUserService';
import { MatrixEventService } from './services/MatrixEventService';
import { MatrixClientEventEmitter } from './MatrixClientEventEmitter';
var logger = new Logger('MatrixClient');
var IMMEDIATE_POLLING_RETRIES = 3;
var RETRY_INTERVAL = 5000;
/**
 * The matrix client used to connect to the matrix network
 */

export var MatrixClient = /*#__PURE__*/function () {
  function MatrixClient(store, eventEmitter, userService, roomService, eventService, httpClient) {
    var _this = this;

    _classCallCheck(this, MatrixClient);

    this.store = store;
    this.eventEmitter = eventEmitter;
    this.userService = userService;
    this.roomService = roomService;
    this.eventService = eventService;
    this.httpClient = httpClient;
    this.isActive = true;
    this._isReady = new ExposedPromise();
    this.store.onStateChanged(function (oldState, newState, stateChange) {
      _this.eventEmitter.onStateChanged(oldState, newState, stateChange);
    }, 'rooms');
  }
  /**
   * Create a matrix client based on the options provided
   *
   * @param config
   */


  _createClass(MatrixClient, [{
    key: "joinedRooms",
    get:
    /**
     * Return all the rooms we are currently part of
     */
    function get() {
      var _this2 = this;

      return new Promise(function (resolve) {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.isConnected();

                case 2:
                  resolve(Object.values(this.store.get('rooms')).filter(function (room) {
                    return room.status === MatrixRoomStatus.JOINED;
                  }));

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
      });
    }
    /**
     * Return all the rooms to which we have received invitations
     */

  }, {
    key: "invitedRooms",
    get: function get() {
      var _this3 = this;

      return new Promise(function (resolve) {
        return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this.isConnected();

                case 2:
                  resolve(Object.values(this.store.get('rooms')).filter(function (room) {
                    return room.status === MatrixRoomStatus.INVITED;
                  }));

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
      });
    }
    /**
     * Return all the rooms that we left
     */

  }, {
    key: "leftRooms",
    get: function get() {
      var _this4 = this;

      return new Promise(function (resolve) {
        return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return this.isConnected();

                case 2:
                  resolve(Object.values(this.store.get('rooms')).filter(function (room) {
                    return room.status === MatrixRoomStatus.LEFT;
                  }));

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
      });
    }
    /**
     * Initiate the connection to the matrix node and log in
     *
     * @param user
     */

  }, {
    key: "start",
    value: function start(user) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _this5 = this;

        var response, initialPollingResult;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.userService.login(user.id, user.password, user.deviceId);

              case 2:
                response = _context7.sent;
                _context7.next = 5;
                return this.store.update({
                  accessToken: response.access_token
                });

              case 5:
                initialPollingResult = new Promise(function (resolve, reject) {
                  return __awaiter(_this5, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                    var _this6 = this;

                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return this.poll(0, function (pollingResponse) {
                              return __awaiter(_this6, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                                  while (1) {
                                    switch (_context4.prev = _context4.next) {
                                      case 0:
                                        if (!this.store.get('isRunning')) {
                                          resolve();
                                        }

                                        _context4.next = 3;
                                        return this.store.update({
                                          isRunning: true,
                                          syncToken: pollingResponse.next_batch,
                                          pollingTimeout: 30000,
                                          pollingRetries: 0,
                                          rooms: MatrixRoom.fromSync(pollingResponse.rooms)
                                        });

                                      case 3:
                                      case "end":
                                        return _context4.stop();
                                    }
                                  }
                                }, _callee4, this);
                              }));
                            }, function (error) {
                              return __awaiter(_this6, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                                  while (1) {
                                    switch (_context5.prev = _context5.next) {
                                      case 0:
                                        if (!this.store.get('isRunning')) {
                                          reject(error);
                                        }

                                        _context5.next = 3;
                                        return this.store.update({
                                          isRunning: false,
                                          pollingRetries: this.store.get('pollingRetries') + 1
                                        });

                                      case 3:
                                      case "end":
                                        return _context5.stop();
                                    }
                                  }
                                }, _callee5, this);
                              }));
                            });

                          case 2:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6, this);
                  }));
                });
                initialPollingResult.then(function () {
                  _this5._isReady.resolve();
                }).catch(console.error);
                return _context7.abrupt("return", initialPollingResult);

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "isConnected",
    value: function isConnected() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this._isReady.promise);

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
    /**
     * Stop all running requests
     */

  }, {
    key: "stop",
    value: function stop() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                logger.log("MATRIX CLIENT STOPPED");
                this.isActive = false;
                this._isReady = new ExposedPromise();
                return _context9.abrupt("return", this.httpClient.cancelAllRequests());

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
    /**
     * Subscribe to new matrix events
     *
     * @param event
     * @param listener
     */

  }, {
    key: "subscribe",
    value: function subscribe(event, listener) {
      this.eventEmitter.on(event, listener);
    }
    /**
     * Unsubscribe from matrix events
     *
     * @param event
     * @param listener
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(event, listener) {
      if (listener) {
        this.eventEmitter.removeListener(event, listener);
      }
    }
    /**
     * Unsubscribe from all matrix events of this type
     *
     * @param event
     * @param listener
     */

  }, {
    key: "unsubscribeAll",
    value: function unsubscribeAll(event) {
      this.eventEmitter.removeAllListeners(event);
    }
  }, {
    key: "getRoomById",
    value: function getRoomById(id) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.isConnected();

              case 2:
                return _context10.abrupt("return", this.store.getRoom(id));

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
    /**
     * Create a private room with the supplied members
     *
     * @param members Members that will be in the room
     */

  }, {
    key: "createTrustedPrivateRoom",
    value: function createTrustedPrivateRoom() {
      for (var _len = arguments.length, members = new Array(_len), _key = 0; _key < _len; _key++) {
        members[_key] = arguments[_key];
      }

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _this7 = this;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.isConnected();

              case 2:
                return _context12.abrupt("return", this.requiresAuthorization('createRoom', function (accessToken) {
                  return __awaiter(_this7, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
                    var response;
                    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            _context11.next = 2;
                            return this.roomService.createRoom(accessToken, {
                              room_version: '5',
                              invite: members,
                              preset: 'public_chat',
                              is_direct: true
                            });

                          case 2:
                            response = _context11.sent;
                            return _context11.abrupt("return", response.room_id);

                          case 4:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11, this);
                  }));
                }));

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
    /**
     * Invite user to rooms
     *
     * @param user The user to be invited
     * @param roomsOrIds The rooms the user will be invited to
     */

  }, {
    key: "inviteToRooms",
    value: function inviteToRooms(user) {
      for (var _len2 = arguments.length, roomsOrIds = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        roomsOrIds[_key2 - 1] = arguments[_key2];
      }

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var _this8 = this;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.isConnected();

              case 2:
                _context13.next = 4;
                return this.requiresAuthorization('invite', function (accessToken) {
                  return Promise.all(roomsOrIds.map(function (roomOrId) {
                    var room = _this8.store.getRoom(roomOrId);

                    _this8.roomService.inviteToRoom(accessToken, user, room).catch(function (error) {
                      return logger.warn('inviteToRooms', error);
                    });
                  }));
                });

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
    /**
     * Join rooms
     *
     * @param roomsOrIds
     */

  }, {
    key: "joinRooms",
    value: function joinRooms() {
      for (var _len3 = arguments.length, roomsOrIds = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        roomsOrIds[_key3] = arguments[_key3];
      }

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var _this9 = this;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.isConnected();

              case 2:
                _context14.next = 4;
                return this.requiresAuthorization('join', function (accessToken) {
                  return Promise.all(roomsOrIds.map(function (roomOrId) {
                    var room = _this9.store.getRoom(roomOrId);

                    return _this9.roomService.joinRoom(accessToken, room);
                  }));
                });

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
    /**
     * Send a text message
     *
     * @param roomOrId
     * @param message
     */

  }, {
    key: "sendTextMessage",
    value: function sendTextMessage(roomId, message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var _this10 = this;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.isConnected();

              case 2:
                _context16.next = 4;
                return this.requiresAuthorization('send', function (accessToken) {
                  return __awaiter(_this10, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
                    var txnId;
                    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                      while (1) {
                        switch (_context15.prev = _context15.next) {
                          case 0:
                            _context15.next = 2;
                            return this.createTxnId();

                          case 2:
                            txnId = _context15.sent;
                            return _context15.abrupt("return", this.eventService.sendMessage(accessToken, roomId, {
                              msgtype: 'm.text',
                              body: message
                            }, txnId));

                          case 4:
                          case "end":
                            return _context15.stop();
                        }
                      }
                    }, _callee15, this);
                  }));
                });

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }
    /**
     * Poll the server to get the latest data and get notified of changes
     *
     * @param interval
     * @param onSyncSuccess
     * @param onSyncError
     */

  }, {
    key: "poll",
    value: function poll(interval, onSyncSuccess, onSyncError) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var _this11 = this;

        var store, sync, pollSync;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                store = this.store;
                sync = this.sync.bind(this);

                pollSync = function pollSync(resolve, reject) {
                  return __awaiter(_this11, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
                    var _this12 = this;

                    var syncingRetries, response;
                    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
                      while (1) {
                        switch (_context18.prev = _context18.next) {
                          case 0:
                            syncingRetries = 0;
                            _context18.prev = 1;
                            _context18.next = 4;
                            return sync();

                          case 4:
                            response = _context18.sent;
                            onSyncSuccess(response);
                            _context18.next = 13;
                            break;

                          case 8:
                            _context18.prev = 8;
                            _context18.t0 = _context18["catch"](1);
                            onSyncError(_context18.t0);
                            syncingRetries = store.get('pollingRetries'); // console.warn('Could not sync:', error)

                            if (this.isActive) {
                              logger.log("Retry syncing... ".concat(syncingRetries, " retries so far"));
                            }

                          case 13:
                            _context18.prev = 13;

                            if (this.isActive) {
                              setTimeout(function () {
                                return __awaiter(_this12, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
                                  return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                                    while (1) {
                                      switch (_context17.prev = _context17.next) {
                                        case 0:
                                          _context17.next = 2;
                                          return pollSync(resolve, reject);

                                        case 2:
                                        case "end":
                                          return _context17.stop();
                                      }
                                    }
                                  }, _callee17);
                                }));
                              }, syncingRetries > IMMEDIATE_POLLING_RETRIES ? RETRY_INTERVAL + interval : interval);
                            } else {
                              reject(new Error("Syncing stopped manually."));
                            }

                            return _context18.finish(13);

                          case 16:
                          case "end":
                            return _context18.stop();
                        }
                      }
                    }, _callee18, this, [[1, 8, 13, 16]]);
                  }));
                };

                return _context19.abrupt("return", new Promise(pollSync));

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    }
    /**
     * Get state from server
     */

  }, {
    key: "sync",
    value: function sync() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var _this13 = this;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt("return", this.requiresAuthorization('sync', function (accessToken) {
                  return __awaiter(_this13, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
                    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                      while (1) {
                        switch (_context20.prev = _context20.next) {
                          case 0:
                            return _context20.abrupt("return", this.eventService.sync(accessToken, {
                              pollingTimeout: this.store.get('pollingTimeout'),
                              syncToken: this.store.get('syncToken')
                            }));

                          case 1:
                          case "end":
                            return _context20.stop();
                        }
                      }
                    }, _callee20, this);
                  }));
                }));

              case 1:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
    }
    /**
     * A helper method that makes sure an access token is provided
     *
     * @param name
     * @param action
     */

  }, {
    key: "requiresAuthorization",
    value: function requiresAuthorization(name, action) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        var storedToken;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                storedToken = this.store.get('accessToken');

                if (storedToken) {
                  _context22.next = 3;
                  break;
                }

                return _context22.abrupt("return", Promise.reject("".concat(name, " requires authorization but no access token has been provided.")));

              case 3:
                return _context22.abrupt("return", action(storedToken));

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));
    }
    /**
     * Create a transaction ID
     */

  }, {
    key: "createTxnId",
    value: function createTxnId() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        var timestamp, counter;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                timestamp = new Date().getTime();
                counter = this.store.get('txnNo');
                _context23.next = 4;
                return this.store.update({
                  txnNo: counter + 1
                });

              case 4:
                return _context23.abrupt("return", "m".concat(timestamp, ".").concat(counter));

              case 5:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
    }
  }], [{
    key: "create",
    value: function create(config) {
      var store = new MatrixClientStore(config.storage);
      var eventEmitter = new MatrixClientEventEmitter();
      var httpClient = new MatrixHttpClient(config.baseUrl);
      var accountService = new MatrixUserService(httpClient);
      var roomService = new MatrixRoomService(httpClient);
      var eventService = new MatrixEventService(httpClient);
      return new MatrixClient(store, eventEmitter, accountService, roomService, eventService, httpClient);
    }
  }]);

  return MatrixClient;
}();